import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CourseService } from 'src/app/services/http/business/course/course.service';

@Component({
  selector: 'app-teacher-selection.component',
  templateUrl: './teacher-selection.component.html',
  styleUrls: ['./teacher-selection.component.css']
})
export class TeacherSelectionComponent implements OnInit {
  form: FormGroup;
  userEncryptId=null;
  teachersList = [];
  teachersListMain = [];

  constructor(
    private fb: FormBuilder,
    private courseService: CourseService,
    private dialog: MatDialogRef<TeacherSelectionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.getTeacher();
    this.createForm();
  }

  createForm() {

    this.form = this.fb.group({
      TeacherUserEncryptId: [null,this.userEncryptId?null:Validators.required],
    });
  }

  filterOptione(key){
    this.teachersList = this.teachersListMain.filter(function(e){
      return e.FirstName.includes(key) || e.LastName.includes(key)
    })
  }

  getTeacher() {

    let command = {
      SessionId: this.data.SessionId,
      StartTime: this.data.StartTime,
      SessionDate: this.data.SessionDate,
      IsMakeUp: this.data.IsMakeUp,
    };

    this.courseService.getFreeSubTeacher(command).subscribe(
      res => {

        this.teachersListMain = res;
        this.teachersList = res;
        let temp = this.teachersList.find(teacher => teacher.UserEncryptId == this.data.TeacherUserEncryptId);
        this.userEncryptId= temp?temp.UserEncryptId:null;
      },
    );
  }

  submit(data: any) {

    if (data.TeacherUserEncryptId)
      this.data["TeacherUserEncryptId"] = data.TeacherUserEncryptId;
     else
      this.data["TeacherUserEncryptId"]=this.userEncryptId;

    this.dialog.close(this.data);

  }
  onNoClick() {
    this.dialog.close();
  }
}
